import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Typography, Box, Button, makeStyles,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import MyForm from '../../form/MyForm';
import pageUtilsPropTypes from '../page-prop-types';
import { AppState } from '../../state/MyStateProvider';
import AuthPage from '../AuthPage';
import SeedAuthenticationRepository from '../../repository/SeedAuthenticationRepository';
import { seedLoginValidationSchema, seedLoginFields } from './seed-login-form';
import formFieldsPropTypes from '../../form/form-prop-types';
import prepareFormikInitialValues from '../../form/form-helpers';
import seedLogo from '../../images/logo.svg';
import { seedAppIcons } from '../../icon/seed-icons';
import { useSearchParams } from '../../route/route-helpers';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  logo: {
    width: 200,
    height: 'auto',
  },
}));

const SeedLoginPage = (props) => {
  const {
    fields,
    validationSchema,
    AuthenticationRepository,
    pageUtils,
    showRegisterButton,
    logo,
    applicationName,
    icons,
  } = props;
  const classes = useStyles();
  const history = useHistory();
  const search = useSearchParams();
  const redirect = search.get('redirect');
  const { state, dispatch } = React.useContext(AppState);

  const [isLoading, setIsLoading] = React.useState(false);
  const [authRepo] = React.useState(new AuthenticationRepository(state, dispatch));

  const handleSubmitLogin = (values) => {
    setIsLoading(true);
    pageUtils.loadSomethingSilent(
      () => authRepo.login(values),
      (payload) => {
        authRepo.saveUser(payload);
        if (redirect) {
          history.push(redirect);
        }
      },
      (error) => {
        if (error.message) {
          pageUtils.showSnackbar(error.message, 'error');
        } else {
          pageUtils.showSnackbar(error, 'error');
        }
        setIsLoading(false);
      },
      () => { },
    );
  };
  const initialValues = prepareFormikInitialValues(null, true, fields);

  return (
    <AuthPage isLoading={isLoading} logo={logo}>
      <div className={classes.logoContainer}>
        <img className={classes.logo} alt={`${applicationName} Logo`} src={logo} />
      </div>
      <Typography align="center" component="h1" variant="h5">
        <FormattedMessage id="seed.login.heading" values={{ applicationName }} />
      </Typography>
      <Box mt={6} />
      <MyForm
        fields={fields}
        validationSchema={validationSchema}
        onSubmit={handleSubmitLogin}
        disabled={isLoading}
        submitButtonLabelId="seed.login.button.submit"
        initialValues={initialValues}
        icons={icons}
      />
      {
        showRegisterButton ? (
          <Box mt={3} align="center">
            <Button href="/register">
              <FormattedMessage id="seed.button.register" />
            </Button>
          </Box>
        ) : ''
      }
    </AuthPage>
  );
};

SeedLoginPage.propTypes = {
  fields: PropTypes.arrayOf(formFieldsPropTypes),
  validationSchema: PropTypes.object,
  AuthenticationRepository: PropTypes.func,
  pageUtils: pageUtilsPropTypes.isRequired,
  showRegisterButton: PropTypes.bool,
  logo: PropTypes.string,
  applicationName: PropTypes.string,
  icons: PropTypes.objectOf(PropTypes.object),
};

SeedLoginPage.defaultProps = {
  fields: seedLoginFields,
  validationSchema: seedLoginValidationSchema,
  AuthenticationRepository: SeedAuthenticationRepository,
  showRegisterButton: true,
  logo: seedLogo,
  applicationName: 'react-seed',
  icons: seedAppIcons,
};

export default SeedLoginPage;
